import { render, staticRenderFns } from "./DialogCreateCourse.vue?vue&type=template&id=189d9988&"
import script from "./DialogCreateCourse.vue?vue&type=script&lang=js&"
export * from "./DialogCreateCourse.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreateCourse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports